import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DataGrid, GridActionsCellItem} from '@mui/x-data-grid';
import AxiosInstance from '../components/Axios'; 
import {
  Grid,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import Partners from './Partners';
import { ExpandMore } from '@mui/icons-material';
import PartnersAdmin from './PartnersAdmin';

const predefinedNames = [
  'Social Media',
  'Events',
  'Social Activities',
  'Web Activities',
  'Audiences',
  'Reporting Period',
  'Participations',
  'Status',
  'Followers',
  'Visitors'
];
const socialMediaOptions = ['Instagram', 'Youtube', 'Facebook', 'Tiktok', 'Twitter', 'Others'];
const reportingPeriodOptions = ['RP1', 'RP2', 'RP3'];
const socialActivitiesOptions = ['Post', 'Video', 'Others'];
const webActivitiesOptions = ['Blog', 'Press-release', 'Newsletter', 'Public deliverable', 'Whitepaper', 'Web News', 'Tutorial', 'Others'];
const audiencesOptions = ['Academia', 'Teachers	', 'Schools', 'Parents', 'Investors', 'Group2 (15-18)', 'Group3 (19-24)', 'Healthcare professionals',
  'Businesses', 'Policymakers and regulators', 'Others'];
const eventsOptions = ['Conference', 'Workshop', 'Webinar', 'Seminars', 'Technical Workshops'
  , 'Participation in a Conference', 'Virtual/Physical Trainings', 'Participation in a Workshop', 'Summer school', 'Fairs', 'Expos', 'Others'];
const participationsOptions = ['Poster', 'Non-scientific and non-peer-reviewed publications ',
  'Stand', 'Video/Film', 'Flyer', 'Press Releases/Communication Campaigns (Radio, TV etc.) ', 'Demo', 'Training package', 'Others'];
const statusOptions = ['Abstract accepted', 'Abstract submitted', 'Paper submitted', 'Paper accepted', 'Others'];
const FollowersOptions = ['Facebook', 'Tiktok', 'Linkedin', 'Twitter'];
const VisitorsOptions = ['Facebook', 'Tiktok ', 'Linkedin', 'Twitter'];


const DefinePartners = () => {

  const is_admin = localStorage.getItem('is_admin')
  return (
    <Grid>
      <Partners/>
    </Grid>
  );
};

export default DefinePartners;
